import { render } from "./NotificationBox.vue?vue&type=template&id=69e96dd0"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__